import { __decorate } from "tslib";
//NPM
import { Component, Mixins } from "vue-property-decorator";
import * as _ from "lodash";
import { interpret } from "xstate";
import simplebar from "simplebar-vue";
//QUINLAN
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import ListManagerMachine from "./machines/listManagerMachine";
import { MasterModel } from "@/store/models/list/master";
import { DetailModel } from "@/store/models/list/detail";
import { AppListModule } from "@/store/modules/listmanager.module";
import ListMasterUpsertComponent from "./components/ListMasterUpsertComponent.vue";
import ListDetailUpsertComponent from "./components/ListDetailUpsertComponent.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
let ListManager = /** @class */ (() => {
    let ListManager = class ListManager extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.title = "List Manager";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Masters",
                    href: "#",
                },
                {
                    text: "List Manager",
                    active: true,
                },
            ];
            this.searchKey = "";
            // --> Pointer
            this.newListMaster = null;
            this.selectedListId = "";
            this.selectedMasterIdForDelete = "";
            this.newList = null;
            this.listUnderEdit = null;
            this.newListItem = null;
            this.listItemUnderEdit = null;
            this.selectedDetailIdIdForDelete = "";
            this.ModalMaster = false;
            // MACHINE
            this.machine = ListManagerMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        // METHODS
        send(event) {
            this.machineService.send(event);
        }
        getlistName() {
            return this.lists.find((x) => x.id == this.selectedListId).masterName;
        }
        selectList(listId) {
            this.selectedListId = listId;
            this.machine.context.masterId = this.selectedListId;
            this.send({ type: "LOAD_LISTITEMS", masterId: this.selectedListId });
        }
        addNewList() {
            this.newList = new MasterModel();
            this.searchKey = "";
            this.send({ type: "ADDING_LIST" });
        }
        saveNewList() {
            this.send({ type: "SAVE_LIST", newList: this.newList });
        }
        editList(list) {
            this.listUnderEdit = Object.assign({}, list);
            this.send({ type: "EDIT_LIST" });
        }
        amIaListUnderEdit(list) {
            if (this.listUnderEdit != null) {
                return this.listUnderEdit.id == list.id;
            }
            return false;
        }
        updateList() {
            this.send({ type: "UPDATE_LIST", updateList: this.listUnderEdit });
        }
        addListItem() {
            this.newListItem = new DetailModel();
            this.send({ type: "ADDING_LIST_ITEM" });
        }
        saveListItem() {
            this.newListItem.masterId = this.selectedListId;
            this.send({ type: "SAVING_LIST_ITEM", newListItem: this.newListItem });
        }
        editListItem(item) {
            this.listItemUnderEdit = Object.assign({}, item);
            this.send({ type: "EDITING_LIST_ITEM" });
        }
        amIaListItemUnderEdit(item) {
            if (this.listItemUnderEdit != null) {
                return this.listItemUnderEdit.id == item.id;
            }
            return false;
        }
        updateListItem() {
            this.send({
                type: "UPDATE_LIST_ITEM",
                updateListItem: this.listItemUnderEdit,
            });
        }
        closeModalMaster() {
            this.send({ type: "CANCEL_DELETE_LIST" });
        }
        closeModalDetail() {
            this.send({ type: "CANCEL_DELETE_LIST_ITEM" });
        }
        selectDeletingMasterId(masterId) {
            this.send({ type: "DELETE_LIST" });
            this.selectedMasterIdForDelete = masterId;
        }
        deleteMaster() {
            this.send({
                type: "DELETING_LIST",
                masterId: this.selectedMasterIdForDelete,
            });
        }
        selectDeletingDetailId(detailId) {
            this.send({ type: "DELETE_LIST_ITEM" });
            this.selectedDetailIdIdForDelete = detailId;
        }
        deleteDetail() {
            this.send({
                type: "DELETING_LIST_ITEM",
                detailId: this.selectedDetailIdIdForDelete,
            });
        }
        get lists() {
            return _.sortBy(AppListModule.masters, (item) => item.masterName);
        }
        get listItems() {
            return _.sortBy(AppListModule.details, (item) => item.code);
        }
        get filteredMaster() {
            if (this.searchKey != "") {
                return AppListModule.masters.filter((x) => x.masterName.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1);
            }
            return AppListModule.masters;
        }
        get sortedFilteredMaster() {
            return _.sortBy(this.filteredMaster, (o) => o.masterName);
        }
        created() {
            this.machineService.onTransition((state) => {
                var prevState = this.state;
                this.state = state;
                if (this.state.matches("gettingLists") || this.state.matches("gettingListItems")) {
                    this.$bvModal.hide("detail-delete");
                    this.$bvModal.hide("list-delete");
                }
                if (this.state.matches("loadedLists")) {
                    this.listUnderEdit = null;
                }
                if (this.state.matches("loadedListItems.listing")) {
                    this.listItemUnderEdit = null;
                }
                if (this.state.matches("deleteList")) {
                    this.$bvModal.show("list-delete");
                }
                if (this.state.matches("loadedListItems.deleteListItem")) {
                    this.$bvModal.show("detail-delete");
                }
                if (prevState.matches("loadedListItems.deleteListItem") && this.state.matches("loadedListItems")) {
                    this.$bvModal.hide("detail-delete");
                }
            });
            this.machineService.start();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    ListManager = __decorate([
        Component({
            name: "ListManager",
            components: {
                Layout,
                PageHeader,
                Loader,
                simplebar,
                ListMasterUpsertComponent,
                ListDetailUpsertComponent,
                SectionLoader,
                DeleteComponent,
            },
        })
    ], ListManager);
    return ListManager;
})();
export default ListManager;
